import { configService } from './service';
import { route } from './router';
import { registerI18n } from './i18n';
export function enable(context) {
    const { i18n, router, container, boBaseUrl, } = context;
    configService({
        container,
        boBaseUrl,
    });
    router.addRoutes(route);
    registerI18n(i18n);
}
